module.exports = __webpack_public_path__ + "img/car_blue.72212524.png";